// Bilder externer Anbieter laufen über die eigene Domain (Vercel-Rewrite in vercel.json),
// damit Besucher-IP-Adressen nicht an den Bildanbieter übermittelt werden.
const PROXIED_HOSTS = { "images.unsplash.com": "/_img" };

const proxyAvailable = () => {
  const h = window.location.hostname.toLowerCase();
  return !(h === "localhost" || h === "127.0.0.1" || h.endsWith(".emergentagent.com"));
};

export function proxiedImageUrl(url) {
  if (!url || typeof url !== "string" || !proxyAvailable()) return url;
  try {
    const u = new URL(url);
    const prefix = PROXIED_HOSTS[u.hostname];
    return prefix ? `${prefix}${u.pathname}${u.search}` : url;
  } catch {
    return url;
  }
}

export function proxyPageImages(page) {
  const c = page?.content;
  if (!c) return page;
  const imgs = c.images || {};
  return {
    ...page,
    content: {
      ...c,
      hero_image: proxiedImageUrl(c.hero_image),
      trust_image: proxiedImageUrl(c.trust_image),
      images: {
        ...imgs,
        hero: proxiedImageUrl(imgs.hero),
        about: proxiedImageUrl(imgs.about),
        services: (imgs.services || []).map(proxiedImageUrl),
        gallery: (imgs.gallery || []).map(proxiedImageUrl),
      },
    },
  };
}
